import React from 'react';

import {Backdrop} from '@mui/material';
import DatePicker from 'react-datepicker';
import {useTranslation} from 'react-i18next';

import CustomHeader from './CustomHeader.js';
import {StyledPickerContainer} from './Style.js';

import ZmSpinner from 'Components/ZmSpinner/index.js';

import './override.css';

/**
 * Date Picker Component
 * @param {Object} props
 * @return {ReactElement}
 */
export default function BookingDayPicker(props) {
  const {disableNextMonth, displayTodayBtn, loadingMonth, offset, size, ...otherProps} = props;
  const {t} = useTranslation();

  return (
    <StyledPickerContainer size={size} offset={offset}>
      <Backdrop
        sx={{
          position: 'absolute',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
        }}
        open={loadingMonth}
      >
        <ZmSpinner absolute size={'40'}/>
      </Backdrop>
      <DatePicker
        key={`${otherProps?.selected}`}
        todayButton={displayTodayBtn ? t('common.today') : undefined}
        {...otherProps}
        renderCustomHeader={(headerProps) => <CustomHeader {...headerProps} disableNextMonth={disableNextMonth}/>}
      />
    </StyledPickerContainer>
  );
}
